import { AbiEntry } from '../services/trustline';

export interface AbiValidationResult {
  valid: boolean;
  error?: string;
  parsed?: AbiEntry[];
}

/**
 * Same rules as the onboarding Step4 ABI check: JSON array with ≥1 function.
 */
export function validateContractAbi(abiText: string): AbiValidationResult {
  const trimmed = abiText.trim();
  if (!trimmed) {
    return { valid: false, error: 'ABI is required' };
  }

  try {
    const parsed = JSON.parse(trimmed);
    if (!Array.isArray(parsed)) {
      return { valid: false, error: 'ABI must be a JSON array' };
    }
    if (parsed.length === 0) {
      return { valid: false, error: 'ABI must be a non-empty JSON array' };
    }
    const hasFunctions = parsed.some(
      (item: any) => item && item.type === 'function' && item.name
    );
    if (!hasFunctions) {
      return { valid: false, error: 'ABI should contain at least one named function definition' };
    }
    return { valid: true, parsed: parsed as AbiEntry[] };
  } catch {
    return { valid: false, error: 'Invalid JSON format' };
  }
}
